module.exports = __webpack_public_path__ + "static/media/mail-icon.42890b92.svg";